import { Fragment, ReactNode } from 'react';
import { tokenizeWhatsappText, tWhatsappToken } from 'src/functions/whatsappFormat.functions';

const MARKERS = { bold: '*', italic: '_', strike: '~' };

const renderTokens = (tokens: tWhatsappToken[], variableClassName?: string): ReactNode =>
  tokens.map((token, index) => {
    if (token.type === 'text') return <Fragment key={index}>{token.value}</Fragment>;
    if (token.type === 'variable') {
      return variableClassName ? (
        <span key={index} className={variableClassName}>{token.value}</span>
      ) : (
        <Fragment key={index}>{token.value}</Fragment>
      );
    }
    // Preserve the enclosing marker as the boundary for nested emphasis.
    const children = renderTokens(
      tokenizeWhatsappText(token.value, MARKERS[token.type]),
      variableClassName,
    );
    switch (token.type) {
      case 'bold':
        return <strong key={index}>{children}</strong>;
      case 'italic':
        return <em key={index}>{children}</em>;
      case 'strike':
        return <s key={index}>{children}</s>;
    }
  });

/** Render text nodes only; recursively format emphasis without parsing HTML. */
export const formatWhatsappText = (text: string, variableClassName?: string): ReactNode =>
  text ? renderTokens(tokenizeWhatsappText(text), variableClassName) : null;
